import { fabric } from "fabric";
import reduxStore from "../configureEnvStore";
import Localize from "../locale/Localize";
import { setCallParticipants, setIsLocationOnVideoIsVisible } from "../reducers/common-reducer";
import {
    setDisableMeasurementBtn,
    setDisableUndoButton,
    setIsMeasurementListDrawerOpen,
    setMeasurementInProgress,
    setMeasurementList,
    setMeasurementStarted,
    setMeasurementStatusPopup,
    setMeasurementToastMsgStatus,
    setMeasurementView,
    setShowMeasurementToastPopup,
} from "../reducers/measurement-reducer";
import extractTextService from "./extractTextService";
import zoomService from "./zoomService";
import { LogFirebase } from "./firestore";
import { sendDataTrack } from "../shared/dataTrackFunction";
import { deviceDetailsAllowed } from "../shared/function";
import { DEVICE_TYPES, MEASUREMENT_VIEW } from "../constants/Constants";
import { NOTIFICATION_TYPES } from "../constants/DataTrackNotificationConstants";
import { AR_MEASUREMENT_ACTION, AR_STATUS, AR_STATUS_LIST } from "../constants/MeasurementConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../constants/PublicVariables";
import { AGENTDEFAULTCOLOR } from "../constants/LivePointerConstants";
import CustomToast from "../components/UI/customToast";
import { QUALITY_TYPE_MAP } from "../constants/CallSettingConstants";
import { addRemoveAutoWidthClass } from "../components/CallScreens/CallTopbar/CallSettings/CallSettingUtils";

class MeasurementService {
    measurementCanvas = null;
    local_pointer = null;

    handleUserMeasurementStatus = function (msg) {
        setTimeout(() => {
            const { callParticipants } = reduxStore.getState().commonReducer;
            const updatedParticipants = callParticipants.map((user) => {
                if (user.identity == msg.identity) {
                    return { ...user, ar_status: msg.ar_device_supported_status };
                }
                return user;
            });
            reduxStore.dispatch(setCallParticipants(updatedParticipants));
            reduxStore.dispatch(setDisableMeasurementBtn(false));
        }, 2000);
    };

    startMeasurement = (msg) => {
        LogFirebase("Measurement", "send_msg", "Start Measurement");
        if (!GLOBAL_MEETING_DATA.ucid && msg == undefined) {
            return;
        } else if (GLOBAL_MEETING_DATA.ucid && msg == undefined) {
            this.sendStartMeasurementDataTrack();
        } else if (!GLOBAL_MEETING_DATA.ucid && msg != undefined && msg.measurement_status == AR_STATUS.STARTED_MEASUREMENT) {
            // start measurement for guest
            console.error("start measurment for guest");
            LogFirebase("Measurement", "receive_msg", "Measurement started");
        } else if (!GLOBAL_MEETING_DATA.ucid && msg != undefined && msg.measurement_status == AR_STATUS.AR_DEVICE_SUPPORTED_STATUS) {
            // ar device supported status measurement for guest
            // do nothing
        } else if (GLOBAL_MEETING_DATA.ucid && msg != undefined && msg.measurement_status == AR_STATUS.STARTED_MEASUREMENT) {
            LogFirebase("Measurement", "receive_msg", "Measurement started");
        }
    };

    sendStartMeasurementDataTrack = () => {
        const callParticipants = reduxStore.getState().commonReducer.callParticipants;
        const streamingIdentity = reduxStore.getState().twilioEvents.streamingPartiIdentity;
        callParticipants.forEach((user) => {
            if (user.identity == streamingIdentity) {
                if (user.ar_status != "4") {
                    this.commonFuncForSendingARStatusDataTrack(AR_STATUS.AR_DEVICE_SUPPORTED_STATUS); // only show popup to agent and send data track with status '2'
                    this.showMeasurementStatusPopup(user.ar_status);
                } else {
                    reduxStore.dispatch(setMeasurementInProgress(true));
                    extractTextService.onStartPrepareView("Measurement");
                    extractTextService.checkUploadTimeout();
                    this.commonFuncForSendingARStatusDataTrack(AR_STATUS.INITIATED_MEASUREMENT); // start measurement and send data track with status '0'
                }
                LogFirebase("Measurement", "send_msg", {
                    ar_status: user.ar_status,
                    identity: user.identity,
                });
            }
        });
    };

    stopMeasurement = (msg) => {
        if (msg == undefined) {
            this.sendStopMeasurementDataTrack();
            this.stopMeasurementPointer();
            this.measurementStopVariable();
        } else if (
            msg != undefined &&
            (msg.measurement_status == AR_STATUS.EXIT_MEASUREMENT || msg.measurement_status == AR_STATUS.CANCEL_MEASUREMENT)
        ) {
            // exit from the measurement
            // here we can exit for guest/agent canvas
            LogFirebase("Measurement", "stop_measurement_msg_received", {
                usre_identity: msg.identity,
                AR_status: msg.measurement_status,
            });
            this.stopMeasurementPointer("tracknotsend");
            extractTextService.onExitPrepareView(true);
            this.measurementStopVariable();
            console.log("exit from the measurement");
        }
    };

    sendStopMeasurementDataTrack = () => {
        this.commonFuncForSendingARStatusDataTrack(AR_STATUS.EXIT_MEASUREMENT);
        LogFirebase("Measurement", "stop_measurement", "");
    };

    stopMeasurementPointer = (from) => {
        const { currentSelectedVideoQuality } = reduxStore.getState().callSetting;
        if (this.measurementCanvas) {
            this.measurementCanvas.dispose();
            this.measurementCanvas = false;
        }
        this.addRemoveMeasurementPointerBodyCss(false);
        if (currentSelectedVideoQuality?.value !== QUALITY_TYPE_MAP.HD) {
            addRemoveAutoWidthClass(false);
        }
        //handle other feature enable/disable when pointer gets off
        this.toggleFeaturesOnPointerOff();
    };

    toggleFeaturesOnPointerOff = () => {
        const { startLocalVideo } = reduxStore.getState().twilioEvents;

        if (PublicVariables.isMobile) {
            zoomService.disablePinchZoom();
            if (startLocalVideo) {
                setTimeout(() => {
                    zoomService.resetPinchZoom();
                }, 1000);
            }
        }
        reduxStore.dispatch(setIsLocationOnVideoIsVisible(true));
    };

    commonFuncForSendingARStatusDataTrack = (status) => {
        const msg = {
            notification_type: NOTIFICATION_TYPES.MEASUREMENT_START_STOP,
            identity: CALL_DATA.localIdentity,
            device_type: GLOBAL_MEETING_DATA.device_type,
            measurement_status: status,
        };
        sendDataTrack(msg);
    };

    showMeasurementStatusPopup = (status) => {
        if (
            status === AR_MEASUREMENT_ACTION.NOT_SUPPORT_AR ||
            status == AR_MEASUREMENT_ACTION.APP_NOT_INSTALLED ||
            status == AR_MEASUREMENT_ACTION.NEEDS_TO_UPDATE_APP
        ) {
            this.manageMeasurementStatus(status);
        }
    };

    manageMeasurementStatus = (status) => {
        if (
            status === AR_MEASUREMENT_ACTION.NOT_SUPPORT_AR ||
            status === AR_MEASUREMENT_ACTION.APP_NOT_INSTALLED ||
            status === AR_MEASUREMENT_ACTION.NEEDS_TO_UPDATE_APP
        ) {
            reduxStore.dispatch(setMeasurementStatusPopup(status));
        } else if (status === AR_MEASUREMENT_ACTION.SUPPORTED_READY_TO_START) {
            const videoCallView = document.getElementById("video-call");
            videoCallView.style.display = ""; // Removes the "display" style
            extractTextService.onExitPrepareView(true);
            reduxStore.dispatch(setMeasurementInProgress(false));
            reduxStore.dispatch(setMeasurementView(MEASUREMENT_VIEW.START_MEASUREMENT_VIEW));
            reduxStore.dispatch(setMeasurementStarted(true));
            reduxStore.dispatch(setMeasurementStatusPopup(status));
            this.createCanvasForLiveStreameMeasurementPointer();
        } else if (status === AR_MEASUREMENT_ACTION.UNSET_POPUP) {
            reduxStore.dispatch(setMeasurementStatusPopup(""));
            reduxStore.dispatch(setMeasurementList([]));
            reduxStore.dispatch(setIsMeasurementListDrawerOpen(false));
        }
    };

    startStopMeasurement = (msg) => {
        if (msg && msg.measurement_status == AR_STATUS.INITIATED_MEASUREMENT && !GLOBAL_MEETING_DATA.ucid) {
            // for guest user only
            this.initiateMeasurement();
            // here we init view
        } else if (msg && msg.measurement_status == AR_STATUS.STARTED_MEASUREMENT) {
            this.startedMeasurement(msg);
        } else if (msg && msg.measurement_status == AR_STATUS.EXIT_MEASUREMENT) {
            // stop measurement
            this.stopMeasurement(msg);
        } else if (msg && msg.measurement_status == AR_STATUS.AR_DEVICE_SUPPORTED_STATUS) {
            // ar device supported status measurement
            this.startMeasurement(msg);
        } else if (msg && msg.measurement_status == AR_STATUS.CLEAR_MEASUREMENT && GLOBAL_MEETING_DATA.ucid) {
            // ar device supported status measurement
            LogFirebase("Measurement", "msg_received", "clearMeasurement");
            this.handleMeasurementNotification({ action: "clearMeasurement" });
        } else if (msg && msg.measurement_status == AR_STATUS.UNDO_MEASUREMENT && GLOBAL_MEETING_DATA.ucid) {
            // ar device supported status measurement
            LogFirebase("Measurement", "msg_received", "undoMeasurement");
            this.handleMeasurementNotification({ action: "undoMeasurement" });
        } else if (msg && msg.measurement_status == AR_STATUS.CANCEL_MEASUREMENT) {
            this.cancelMeasurement(msg);
        }
    };

    initiateMeasurement = () => {
        reduxStore.dispatch(setMeasurementInProgress(true));
        extractTextService.onStartPrepareView("Measurement");
        extractTextService.checkUploadTimeout();
    };

    startedMeasurement = (msg) => {
        // start measurement
        const { measurementStarted, measurementInProgress } = reduxStore.getState().measurement;
        if (measurementStarted === false) {
            this.startMeasurement(msg);
        }
        if (measurementInProgress === false && msg.for_new_joinee == "1") {
            reduxStore.dispatch(setMeasurementInProgress(true));
            LogFirebase("Measurement", "msg_received", "for new joinee");
            this.manageMeasurementStatus(AR_MEASUREMENT_ACTION.SUPPORTED_READY_TO_START);
        }
    };

    cancelMeasurement = (msg) => {
        // ar device supported status measurement
        LogFirebase("Measurement", "msg_received", "cancelMeasurement");
        this.stopMeasurement(msg);
        const msgType = "Measurement";
        this.hideMeasurementViewAndShowMsg(msgType, msgType.toLowerCase() + "_cancelled");
    };

    cancelMeasurementView = () => {
        const type = "measurement";
        const { measurementInProgress } = reduxStore.getState().measurement;
        if (measurementInProgress) {
            LogFirebase("Measurement", "send_msg", "CancelMeasurement");
            this.measurementStopVariable();
            this.commonFuncForSendingARStatusDataTrack(AR_STATUS.CANCEL_MEASUREMENT);
            this.hideMeasurementViewAndShowMsg(type.toLowerCase() + "_cancelled");
        }
    };

    measurementStopVariable = () => {
        reduxStore.dispatch(setMeasurementInProgress(false));
        reduxStore.dispatch(setMeasurementStarted(false));
        reduxStore.dispatch(setMeasurementView(MEASUREMENT_VIEW.OFF_VIEW));
        this.manageMeasurementStatus(AR_MEASUREMENT_ACTION.UNSET_POPUP);
        const videoCallView = document.getElementById("video-call");
        if (videoCallView.style.display === "none") {
            videoCallView.style.display = ""; // Removes the "display" style
        }
    };

    hideMeasurementViewAndShowMsg = (msg) => {
        extractTextService.onExitPrepareView(true);
        if (msg.indexOf("cancelled") > -1) {
            CustomToast.success(Localize[PublicVariables.currentLanguageObj.languageCode][msg]);
        } else {
            CustomToast.error(Localize[PublicVariables.currentLanguageObj.languageCode][msg]);
        }
    };

    handleMeasurementNotification = (msg) => {
        if (msg.notification_type) {
            if (msg.notification_type === NOTIFICATION_TYPES.AR_MEASUREMENT.AGENT_TO_ALL) {
                reduxStore.dispatch(setDisableUndoButton(!!msg.is_live_measurement));
                if (msg.highlight_measurement == null || msg.highlight_measurement == "" || msg.highlight_measurement == undefined) {
                    ////do nothing for add point
                } else {
                    this.addNewMeasurementPoint(msg);
                }
            } else if (msg.notification_type === NOTIFICATION_TYPES.AR_MEASUREMENT.GUEST_TO_AGENT) {
                this.handleMeasurementToastMessage(msg);
            }
        } else if (msg.action) {
            if (msg.action == "clearMeasurement") {
                this.clearMeasureList();
            } else if (msg.action == "undoMeasurement") {
                this.undoMeasureList();
            }
        }
    };

    // add new measurement point in to array
    addNewMeasurementPoint = (msg) => {
        const measurementList = reduxStore.getState().measurement.measurementList;
        reduxStore.dispatch(setMeasurementList([...measurementList, msg]));
    };

    handleMeasurementToastMessage = (msg) => {
        reduxStore.dispatch(setShowMeasurementToastPopup(true));
        const toastMsgStatus = Localize[PublicVariables.currentLanguageObj.languageCode][AR_STATUS_LIST[msg.measurement_toast_msg_status]];
        reduxStore.dispatch(setMeasurementToastMsgStatus(toastMsgStatus));

        if (msg.measurement_toast_msg_status == 0) {
            setTimeout(function () {
                const { measurementToastMsgStatus } = reduxStore.getState().measurement;
                if (
                    measurementToastMsgStatus ===
                    Localize[PublicVariables.currentLanguageObj.languageCode][AR_STATUS_LIST[msg.measurement_toast_msg_status]]
                ) {
                    reduxStore.dispatch(setShowMeasurementToastPopup(false));
                }
            }, 3000);
        }
    };

    createCanvasForLiveStreameMeasurementPointer = () => {
        const isMobileBrowser =
            GLOBAL_MEETING_DATA.device_type == DEVICE_TYPES.IOS_BROWSER || GLOBAL_MEETING_DATA.device_type == DEVICE_TYPES.ANDROID_BROWSER;

        const videoElement = document.getElementById("expandedVideo")?.querySelector("video");

        if (isMobileBrowser) {
            addRemoveAutoWidthClass(true);
        }

        if (!videoElement) {
            LogFirebase("Measurement", "LiveStream-video_element_not_found", "");
            return;
        }

        const height = videoElement.offsetHeight || videoElement.clientHeight;
        const width = videoElement.offsetWidth || videoElement.clientWidth;

        if (deviceDetailsAllowed()) {
            LogFirebase("Measurement", "LiveStream-videoConstraints", { height, width });
        }

        this.addRemoveMeasurementPointerBodyCss(true);

        if (height && width) {
            const timeOutValue = isMobileBrowser ? 1500 : 1000;

            setTimeout(() => {
                const canvasContainer = document.getElementById("measurementCanvasContainer");
                if (canvasContainer) {
                    let canvas = document.createElement("canvas");
                    canvas.id = "measurementCanvas";
                    canvasContainer.appendChild(canvas);

                    this.measurementCanvas = new fabric.Canvas("measurementCanvas");
                    this.measurementCanvas.setHeight(height);
                    this.measurementCanvas.setWidth(width);
                    this.measurementCanvas.selection = false;

                    extractTextService.closeAllModel();
                    if (GLOBAL_MEETING_DATA.ucid) {
                        this.moveLivePointerForLocal();
                    }
                }
            }, timeOutValue);

            if (GLOBAL_MEETING_DATA.ucid) {
                const languageCode = PublicVariables.currentLanguageObj?.languageCode;
                const message = Localize[languageCode]["measurement_toast_msg_to_guide_user"];
                const note = Localize[languageCode]["measurement_toast_note_to_guide_user"];

                if (message && note) {
                    CustomToast.info(`${message}\n\n${note}`, 15000);
                }
            }
        }
    };

    addRemoveMeasurementPointerBodyCss = (add) => {
        const body = document.body;
        if (add) {
            body.classList.add("ar-measurement-body");
        } else {
            body.classList.remove("ar-measurement-body");
        }
    };

    createPointerShape(x, y, color, scale = 1) {
        // Create an arrow/inspection pointer shape using fabric.Path
        // The path creates a pointer arrow shape pointing to the top-left
        const pointerPath = "M 0 0 L 0 24 L 6 18 L 10 28 L 14 26 L 10 16 L 18 16 Z";

        const pointer = new fabric.Path(pointerPath, {
            left: x,
            top: y,
            fill: color,
            stroke: "#FFFFFF",
            strokeWidth: 1.5,
            hasBorders: false,
            hasControls: false,
            selectable: false,
            evented: false,
            originX: "left",
            originY: "top",
            scaleX: scale,
            scaleY: scale,
            objectCaching: true,
        });

        pointer.set(
            "shadow",
            new fabric.Shadow({
                blur: 4,
                offsetX: 1,
                offsetY: 2,
                color: "#00000040",
            })
        );

        return pointer;
    }

    moveLivePointerForLocal() {
        let localColor = "";
        let pointerScale = 1;
        if (GLOBAL_MEETING_DATA.isAgent) {
            localColor = AGENTDEFAULTCOLOR;
        }

        this.local_pointer = null;

        // Hide the browser's default cursor over the canvas
        this.measurementCanvas.defaultCursor = "none";
        this.measurementCanvas.hoverCursor = "none";
        this.measurementCanvas.moveCursor = "none";

        this.measurementCanvas.on("mouse:move", (o) => {
            let pointer = this.measurementCanvas?.getPointer(o.e);

            //if pointer not added then only add it
            if (this.local_pointer == null) {
                this.local_pointer = this.createPointerShape(pointer?.x, pointer?.y, localColor, pointerScale);
                this.measurementCanvas?.add(this.local_pointer);
            }

            let pointerValue = this.measurementCanvas.getPointer(o.e);
            this.local_pointer.set({ left: pointerValue.x, top: pointerValue.y });
            this.measurementCanvas.renderAll();

            const msg = {
                notification_type: NOTIFICATION_TYPES.AR_MEASUREMENT.POINT,
                identity: CALL_DATA.localIdentity,
                device_type: GLOBAL_MEETING_DATA.device_type,
                annotation_point: JSON.stringify({
                    XPOINTS: parseFloat(pointer.x),
                    YPOINTS: parseFloat(pointer.y),
                    HEIGHT: this.measurementCanvas.getHeight(),
                    WIDTH: this.measurementCanvas.getWidth(),
                    COLOR: localColor,
                    IDENTITY: CALL_DATA.localIdentity,
                }),
            };

            const height = this.measurementCanvas.getHeight();
            const Width = this.measurementCanvas.getWidth();
            if (this.measurementCanvas && height != null && Width != null) {
                sendDataTrack(msg);
            }
        });
        this.measurementCanvas.on("mouse:up", (o) => {
            console.log("isDragging = false;");
        });
    }

    clearMeasureList = () => {
        reduxStore.dispatch(setMeasurementList([]));
        reduxStore.dispatch(setIsMeasurementListDrawerOpen(false));
    };

    undoMeasureList = () => {
        const { measurementList } = reduxStore.getState().measurement;
        const updatedMeasurementList = [...measurementList];
        updatedMeasurementList.pop();
        reduxStore.dispatch(setMeasurementList(updatedMeasurementList));
        if (updatedMeasurementList.length === 0) {
            reduxStore.dispatch(setIsMeasurementListDrawerOpen(false));
        }
    };
}
export default new MeasurementService();
